import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import get from 'lodash/get'

import { AddressBlock } from 'components/sections/common'
import { OfficeGeneralDetails } from 'components/sections/national-offices'
import { SocialLinks } from 'components/sections/organizations'
import { Form } from 'components/layout'
import { FloatingBar, Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { ORGANIZATION_HIERARCHY } from 'constants/enums'
import { getBillingAddressFormStatus } from 'helpers/uiPermissions'
import { Input } from 'components/fields'
import validate from './office-details.validation'
import DetailLoader from 'components/loaders/DetailLoader/DetailLoader'

const showFinData = [ORGANIZATION_HIERARCHY.NAO.id, ORGANIZATION_HIERARCHY.IAC.id]
const showPrfDisc = [ORGANIZATION_HIERARCHY.IAC.id]

const enhance = compose(
  form({
    form: 'national-office-detail',
    initialProps: 'organizations.detail',
    validate,
  })
)

class OfficeDetails extends Component {
  static propTypes = {
    organizations: PropTypes.object.isRequired,
    blobs: PropTypes.object.isRequired,
    values: PropTypes.object,
    codeLists: PropTypes.object,
    files: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    updateMyOrganization: PropTypes.func.isRequired,
    updateOrganizationState: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    onDownloadFile: PropTypes.func.isRequired,
    route: PropTypes.object,
    user: PropTypes.object,
  }

  render() {
    const {
      handleSubmit,
      updateMyOrganization,
      change,
      values,
      files,
      organizations,
      blobs,
      codeLists,
      route,
      user,
    } = this.props

    const [isLicenseeFieldVisible, isAddressReadOnly] = getBillingAddressFormStatus(
      user,
      get(organizations, 'detail.hierarchyLevel.value')
    )
    const loading = blobs.loading || organizations.loading

    return (
      <Form
        onSubmit={handleSubmit(updateMyOrganization)}
        loading={loading}
        contentLoader={<DetailLoader withLogo />}
      >
        <OfficeGeneralDetails
          change={change}
          data={values}
          updateOrganizationState={this.props.updateOrganizationState}
          onDownloadFile={this.props.onDownloadFile}
          files={files}
          organizationStates={codeLists.organizationStates.list}
          showFinancialData={showFinData.includes(route.isTypeId)}
          showPrfDisc={showPrfDisc.includes(route.isTypeId)}
        />
        <div className="row">
          <div className="col-xs-6">
            <AddressBlock
              intlKey="moduleTitle.billing_address"
              formPrefix="invoiceAddress"
              withCountry
              change={change}
              readOnly={isAddressReadOnly}
              prependFields={
                isLicenseeFieldVisible && (
                  <Input
                    label="Licensee name"
                    intlKey="label.organisation_invoicing_name"
                    name="invoicingName"
                    readonly={isAddressReadOnly}
                  />
                )
              }
              isOrganizationAddress
            />
          </div>
          <div className="col-xs-6">
            <AddressBlock
              intlKey="moduleTitle.shipping_address"
              formPrefix="address"
              copyFrom="invoiceAddress"
              withAction
              withCountry
              change={change}
              data={values}
              isOrganizationAddress
            />
            <SocialLinks />
          </div>
        </div>
        <FloatingBar>
          <Button intlKey="button.save">Save</Button>
        </FloatingBar>
      </Form>
    )
  }
}

export default enhance(OfficeDetails)
